import React, { FC } from 'react';
import { Avatar as AntdAvatar } from 'antd';

type Props = {
  src: string;
  className?: string;
  preview?: boolean;
  style?: React.CSSProperties;
};
export const Avatar: FC<Props> = (props) => {
  return <AntdAvatar {...props} />;
};
export default Avatar;
